import type { MessageObject } from '@/client'
import { askQuestionChatbotAskPostMutation } from '@/client/@tanstack/react-query.gen'
import { logger } from '@/utils'
import { useAuthHeaders } from '@/providers'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'

const log = logger.child({
  file: 'src/hooks/useSubmitChatMessageMutation.tsx',
})

export type useSubmitChatMessageMutationProps = {}

export const useSubmitChatMessageMutation = () => {
  const headers = useAuthHeaders()
  const [messages, setMessages] = useState<Array<MessageObject>>([])

  return {
    messages,
    setMessages,
    ...useMutation({
      ...askQuestionChatbotAskPostMutation({
        headers,
      }),
      onMutate: (data) => {
        const { messages: newMessages } = data.body
        const lastMessage = newMessages[newMessages.length - 1]
        setMessages((prevMessages) => {
          return [...prevMessages, lastMessage]
        })
      },
      onSuccess: (data) => {
        log.info({ msg: 'Chat message submitted successfully', data })
        setMessages(data.messages)
      },
      // onError: (error) => {
      //   log.error({ msg: 'Error submitting chat message', error })
      // },
    }),
  }
}
